export default {"src":"/_next/static/media/thread.201eefaf.gif","height":1297,"width":600,"blurWidth":0,"blurHeight":0};